<template>
  <div class="FormRegisterUser">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-text-field
        v-model.trim="firstName"
        label="Primeiro Nome"
        required
      />
      <v-text-field
        v-model.trim="lastName"
        label="Último Nome"
        required
      />
      <v-text-field
        v-model.trim="email"
        label="E-mail"
        type="email"
        required
      />
      <v-text-field
        v-model.trim="password"
        label="Senha"
        :type="showPassword ? 'text' : 'password'"
        :rules="passwordRules"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        required
        counter
        @click:append="showPassword = !showPassword"
      />
      <v-text-field
        v-model.trim="confirmPassword"
        label="Confirmar Senha"
        :type="showPassword ? 'text' : 'password'"
        :rules="[...passwordRules, passwordMatch]"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        required
        counter
        @click:append="showPassword = !showPassword"
      />
      <v-select
        v-model="sex"
        :items="sexItems"
        label="Sexo"
        item-text="label"
        tem-value="value"
      ></v-select>
      <v-checkbox
        v-model="termsAccepted"
        :rules="[v => !!v || 'Você deve aceitar os Termos de Uso para continuar']"
        required
        class="mt-0"
      >
        <template v-slot:label>
          <span class="body-2">
            Li e aceito os
            <a href="https://meli.app.br/termos" target="_blank" rel="noopener" @click.stop>Termos de Uso</a>
          </span>
        </template>
      </v-checkbox>
      <v-btn
        color="primary"
        class="mr-4"
        :disabled="disabled || !termsAccepted"
        block
        @click="register"
      >
        Cadastre-se
      </v-btn>
    </v-form>
    <v-snackbar v-model="snackbar">{{message}}</v-snackbar>
    <v-row
      align-content="center"
    >
      <v-progress-circular
        v-if="disabled"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { UserService } from '../../lib/spasms-control'
import store from '../../store';
import { getDefaultRoute, getUser, saveToken } from '../../utils';
export default {
  name: 'FormRegisterUser',
  props: {
    profileType: {
      type: String,
      default: 'normal'
    }
  },
  data: function () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      passwordRules: [
        v => !!v || 'Senha é obrigatório',
        v => v.length >= 6 || 'Min 6 caracters',
      ],
      showPassword: false,
      sex: '',
      sexItems: [
        {label: 'Masculino', value: 'M'},
        {label: 'Feminino', value: 'F'}
      ],
      termsAccepted: false,
      valid: false,
      snackbar: false,
      disabled: false,
      message: ''
    }
  },
  computed: {
    passwordMatch() {
      return this.password === this.confirmPassword || "A senha deve corresponder";
    }
  },
  methods:{
    register: async function () {
      this.disabled = true
      const service = new UserService()
      const data = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        password: this.password,
        termsAccepted: this.termsAccepted,
        profile: {
          sex: this.sex,
          profileType: this.profileType
        }
      }
      service.register(data).then(data => {
        if (data.id) {
          service.login(this.email, this.password).then(async data => {
            saveToken(data)
            const user = await getUser()
            store.setIsAuthenticatedAction(true)
            this.$router.push({path: getDefaultRoute(user)})
          }).catch(err => {
            console.error({err})
            store.setSnackBarMessageAction(err.response.data.detail)
            store.setShowSnackBarAction(true)
          })
        }

      }).catch(err => {
        console.error(err)
        this.disabled = false
        this.message = err.message
        this.snackbar = true
      })
    }
  }
}
</script>

<style>

</style>
